document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

(() => {
  const body = document.body;
  const overlay = document.querySelector('[data-mobile-overlay]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterClose = document.querySelector('[data-filter-close]');

  const closePanels = () => {
    body.classList.remove('menu-open', 'filter-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
  };

  menuToggle?.addEventListener('click', () => {
    body.classList.add('menu-open');
    menuToggle.setAttribute('aria-expanded', 'true');
  });
  menuClose?.addEventListener('click', closePanels);
  filterToggle?.addEventListener('click', () => body.classList.add('filter-open'));
  filterClose?.addEventListener('click', closePanels);
  overlay?.addEventListener('click', closePanels);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePanels();
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-header-search]').forEach((form) => {
    form.addEventListener('submit', () => {
      const vendor = form.querySelector('[data-header-vendor]')?.value;
      const query = form.querySelector('input[name="q"]');
      if (vendor && query) query.value = `vendor:"${vendor}" ${query.value}`.trim();
    });
  });

  document.querySelectorAll('[data-product-finder]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const category = form.querySelector('[data-finder-category]')?.value || '/collections/all';
      const vendor = form.querySelector('[data-finder-vendor]')?.value;
      const power = form.querySelector('[data-finder-power]')?.value;
      const url = new URL(category, window.location.origin);
      if (vendor) url.searchParams.set('filter.p.vendor', vendor);
      if (power) url.searchParams.set('filter.p.tag', power);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-countdown]').forEach((countdown) => {
    const end = new Date(countdown.dataset.end).getTime();
    if (Number.isNaN(end)) return;
    const render = () => {
      const distance = Math.max(0, end - Date.now());
      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance / 3600000) % 24);
      const minutes = Math.floor((distance / 60000) % 60);
      const seconds = Math.floor((distance / 1000) % 60);
      countdown.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
      countdown.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      countdown.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
      countdown.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
    };
    render();
    window.setInterval(render, 1000);
  });

  const updateCartCount = async () => {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    } catch (_) {}
  };

  const setupQuickAdd = (scope = document) => scope.querySelectorAll('[data-quick-add]').forEach((form) => {
    if (form.dataset.quickAddReady) return;
    form.dataset.quickAddReady = 'true';
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button');
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Ekleniyor…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Cart error');
        button.textContent = 'Sepete eklendi ✓';
        await updateCartCount();
      } catch (_) {
        button.textContent = 'Tekrar deneyin';
      }
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText;
      }, 1800);
    });
  });
  setupQuickAdd();

  document.querySelectorAll('product-recommendations').forEach((element) => {
    const observer = new IntersectionObserver((entries, recommendationObserver) => {
      if (!entries[0].isIntersecting) return;
      recommendationObserver.unobserve(element);
      fetch(element.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const replacement = html.querySelector('product-recommendations');
          if (replacement?.innerHTML.trim()) {
            element.innerHTML = replacement.innerHTML;
            setupQuickAdd(element);
          }
        })
        .catch(() => {});
    }, { rootMargin: '0px 0px 300px 0px' });
    observer.observe(element);
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    root.querySelectorAll('[data-media-target]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        root.querySelectorAll('[data-media-target]').forEach((item) => item.classList.remove('is-active'));
        root.querySelectorAll('[data-media-id]').forEach((item) => item.classList.add('is-hidden'));
        thumb.classList.add('is-active');
        root.querySelector(`[data-media-id="${thumb.dataset.mediaTarget}"]`)?.classList.remove('is-hidden');
      });
    });

    const quantityInput = root.querySelector('[data-quantity-input]');
    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
    });
    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      quantityInput.value = Number(quantityInput.value || 1) + 1;
    });

    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]'); } catch (_) {}
    const variantInput = root.querySelector('[data-variant-id]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addText = root.querySelector('[data-add-text]');
    const stickyAdd = root.querySelector('[data-sticky-add]');
    const currency = body.dataset.currency || 'TRY';
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style: 'currency', currency }).format(cents / 100);

    const updateVariant = () => {
      const selections = [...root.querySelectorAll('[data-option-index]:checked')]
        .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
        .map((input) => input.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === selections[index]));
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (stickyAdd) stickyAdd.disabled = true;
        if (addText) addText.textContent = 'Mevcut değil';
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (addButton) addButton.disabled = !variant.available;
      if (stickyAdd) stickyAdd.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Sepete ekle' : 'Tükendi';
      const price = root.querySelector('[data-product-price]');
      if (price) price.innerHTML = `<div class="price${variant.compare_at_price > variant.price ? ' price--sale' : ''}"><span class="price__current">${money(variant.price)}</span>${variant.compare_at_price > variant.price ? `<s class="price__compare">${money(variant.compare_at_price)}</s>` : ''}</div>`;
      root.querySelectorAll('[data-sticky-price]').forEach((element) => { element.textContent = money(variant.price); });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.featured_media?.id) root.querySelector(`[data-media-target="${variant.featured_media.id}"]`)?.click();
    };
    root.querySelectorAll('[data-option-index]').forEach((input) => input.addEventListener('change', updateVariant));

    stickyAdd?.addEventListener('click', () => addButton?.click());
    const productForm = root.querySelector('[data-product-form]');
    const stickyBar = root.querySelector('[data-sticky-product]');
    if (productForm && stickyBar) {
      new IntersectionObserver(([entry]) => stickyBar.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 }).observe(productForm);
    }
  });
})();
